export default __webpack_public_path__ + "static/media/media.5999d017.svg";